/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LatInputs */

const en__field_lat = /** @type {(inputs: _Field_LatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latitude`)
};

/**
* | output |
* | --- |
* | "Latitude" |
*
* @param {_Field_LatInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_lat = /** @type {((inputs?: _Field_LatInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LatInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_lat(inputs)
});